import React from 'react';
import { ColorFrom, Feature } from '@tencent/workbench';
import { ShadowFeature } from '@framework/workbench/drawer/ui/effects/shadow/shadow-feature';
import { IChartShadowFeature } from './chart-shadow-interface';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import ChartShapeProperty from '@src/slide/domain/ui-model/element-modeles/property/chart/chart-shape-property';
import { TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { IShadowModelVal } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';
import { ColorSelectButton } from '@src/framework/workbench/drawer/components/color-select-button';
import { INPUT_PROPS_CALLBACK_KEY } from '@src/framework/workbench/drawer/constants';
import { handleInputBlurInitAndReset } from '@src/slide/application/service/drawer-input-manager/drawer-handler';
import { AngleFrom, NumberInputFrom, ColorOperations } from '@tencent/wb-ext-form';
import { ChartFormItemKey } from '@tencent/chart-drawer-components/lib/schema';


const defaultShadowProps = {
    color: '#000000',
    tdColor: new TDColor({ rgbaStr: '#000000' }),
    opacity: 0,
    size: 0,
    blurRad: 0,
    dir: 0,
    dist: 0,
    rotWithShape: 0,    // 外阴影该值默认为0
    isOuter: true, /** 默认是外阴影 */
};
const SHADOW_EMPTY = 'shadow-empty';
const SHADOW_TYPE = {
    OUTER: 'outer',
    INNER: 'inner',
    PERSPECTIVE: 'perspective',
};
const DEFAULT_EMPTY_COLOR = '#000000';

@Feature()
export class ChartShadowFeature extends ShadowFeature implements IChartShadowFeature {
    public constructor() {
        super();
        this.addInitPropsCallback(INPUT_PROPS_CALLBACK_KEY.CHART_GLOBAL_SHADOW);
    }

    public getSelectModel(): any {
        const model = super.getSelectModel() as IChartModel;
        if (model?.type == UIModelType.CHART) {
            const chartSpace = model.getChartSpaceProperty() as ChartShapeProperty;
            if (!chartSpace) return model;
            return chartSpace;
        }
        return model;
    }

    public get shadowInfo() {
        const shadow = (this.getSelectModel())?.getEffect?.()
            .getShadow();
        return shadow && Object.keys(shadow).length > 0 ? shadow : defaultShadowProps;
    }

    public updateShadowProps = (onlyChangeUI?: boolean, onPreview?: boolean) => {
        if (onlyChangeUI) return;
        const shadow: IShadowModelVal = onPreview ? { ...this.previewInfo } : (this.shadowProps
            ? { ...this.shadowProps } : this.shadowProps);
        const selectedModel = this.getSelectModel();
        selectedModel.updateEffect({ shadow: { ...shadow } });
        this.updateUIWithShadowData();
    };


    public getColorSelectButton() {
        return <ColorSelectButton
            onColorChange={this.handleShadowColorChange}
            value={this.shadowInfo?.tdColor || new TDColor({ rgbaStr: DEFAULT_EMPTY_COLOR })}
        />;
    }

    public updateUIWithShadowData = () => {
        if (this.getAppService().editableServiceLayer?.previewService?.isPreview) {
            return;
        }
        const shadow = this.shadowInfo;
        this.shadowProps = { ...shadow };
        this.previewInfo = { ...this.shadowInfo };
    };

    public handleShadowPresetStyleClick = (shadow) => {
        this.getAppService().editableServiceLayer?.previewService?.updateElementPreviewState(false);
        this.shadowProps = { ...defaultShadowProps, ...shadow };
        this.updateShadowProps();
        this.handleChartGlobalShadowPresetReport(shadow);
    };

    @handleInputBlurInitAndReset(INPUT_PROPS_CALLBACK_KEY.CHART_GLOBAL_SHADOW)
    public handleShadowChange(value, dragEnd?: boolean, from?: NumberInputFrom | AngleFrom) {
        this.shadowProps = { ...this.shadowInfo, ...value };
        const onlyChangeUI = this.isInputOnlyChangeUIWithDrag(dragEnd);
        this.updateShadowProps(onlyChangeUI);
        this.handleChartGlobalShadowReport(value, from, onlyChangeUI);
    }

    private handleChartGlobalShadowPresetReport = (shadow) => {
        let ver5;
        if (!shadow) {
            ver5 = 1;
        } else {
            ver5 = shadow?.isOuter ? 2 : 3;
        }
        this.tdwDrawerReport(ChartFormItemKey.CHART_GLOBAL_SHADOW, { ver5 });
    };

    private handleChartGlobalShadowReport = (value, from?: any, onlyChangeUI?: boolean) => {
        if (typeof value === 'number') {
            this.tdwDrawerReportAngle(ChartFormItemKey.CHART_GLOBAL_SHADOW_ANGLE, from, value, onlyChangeUI);
        } else {
            let reportId;
            let ver6;
            if (value?.size) {
                reportId  = ChartFormItemKey.CHART_GLOBAL_SHADOW_SIZE;
                ver6 = value.size;
            }
            if (value?.blurRad) {
                reportId  = ChartFormItemKey.CHART_GLOBAL_SHADOW_BLUR;
                ver6 = value.blurRad;
            }
            if (value?.dist) {
                reportId  = ChartFormItemKey.CHART_GLOBAL_SHADOW_DISTANCE;
                ver6 = value.dist;
            }
            if (value?.opacity) {
                reportId  = ChartFormItemKey.CHART_GLOBAL_SHADOW_OPICITY;
                ver6 = value.opacity;
            }
            reportId && this.tdwDrawerReportNumberInput(reportId, { ver6 }, from, onlyChangeUI);
        }
    };
}
